module.exports = __webpack_public_path__ + "img/dg3.2c00ed15.jpg";